module.exports = __webpack_public_path__ + "static/media/bell-exclamation.da412210.svg";